import { getAll, getRecordById } from "../../localDB";
import { activityClassification, sessionType, statusDisplayNames, statusMapping, SyncStatusMap } from "../../visualizations/visualizations";

export const OpalGenerateReports = async (requestBody) => {
    const report = await getAll("session");
    const cyclePeriod = Number(localStorage.getItem("c_id")) || 0;

    if (requestBody.id === "R1") {


        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const filtered = report.filter(a => {
            const sessionDate = new Date(a.SessionDate);
            sessionDate.setHours(0, 0, 0, 0);
            return sessionDate.getTime() === today.getTime() &&
                a.SyncStatus !== SyncStatusMap.done &&
                a.CyclePeriodID === cyclePeriod &&
                a.Tag == null &&
                a.Type !== sessionType.Incidental &&
                a.Activity?.Classification != activityClassification.Event
        });

        const totalCalls = filtered.length;

        const totalFinishedCalls = filtered.filter(a =>
            [statusMapping.pending, statusMapping.inprogress].includes(a.Status)
        ).length;

        return [
            {
                ID: 1,
                Title: "Remaining",
                Progress: totalFinishedCalls || 0,
                Total: totalCalls || 0
            }
        ];
    } else if (requestBody.id === "R2") {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const filtered = report.filter(a => {
            const sessionDate = new Date(a.SessionDate);
            sessionDate.setHours(0, 0, 0, 0);

            return a.CyclePeriodID === cyclePeriod &&
                [statusMapping.pending, statusMapping.inprogress].includes(a.Status) &&
                a.SyncStatus !== SyncStatusMap.done &&
                a.Tag == null &&
                a.Type !== sessionType.Incidental &&
                a.Activity?.Classification != activityClassification.Event
        });

        return [
            {
                Total: filtered.length,
                Data: filtered
            }
        ];
    } else if (requestBody.id === "R3") {
        const filtered = report.filter(a => {
            return a.CyclePeriodID === cyclePeriod &&
                a.SyncStatus !== SyncStatusMap.done &&
                a.Tag == null &&
                a.Type !== sessionType.Incidental &&
                a.Activity?.Classification != activityClassification.Event
        });

        const totalFrequency = filtered.length;

        const totalCalls = filtered.filter(a =>
            [statusMapping.success, statusMapping.recovered, statusMapping.advanced].includes(a.Status)
        ).length;

        return [
            {
                ID: 1,
                Title: "Call Rate",
                Progress: totalCalls || 0,
                Total: totalFrequency || 0
            }
        ];
    } else if (requestBody.id === "R4") {

        const filtered = report.filter(a => {
            return a.CyclePeriodID === cyclePeriod &&
                a.SyncStatus !== SyncStatusMap.done &&
                a.Tag == null &&
                a.Type !== sessionType.Incidental &&
                a.Activity?.Classification != activityClassification.Event
        });

        const totalCustomer = [...new Set(filtered.map(a => a.AccountID))].length;

        const customerVisited = [
            ...new Set(
                filtered
                    .filter(a => [statusMapping.success, statusMapping.recovered, statusMapping.advanced].includes(a.Status))
                    .map(a => a.AccountID)
            )
        ].length;

        return [
            {
                ID: 1,
                Title: "Call Reach",
                Progress: customerVisited || 0,
                Total: totalCustomer || 0
            }
        ];
    } else if (requestBody.id === "R5") {
        const filtered = report.filter(a => {
            return a.CyclePeriodID === cyclePeriod &&
                a.SyncStatus !== SyncStatusMap.done &&
                a.Tag == null &&
                a.Type !== sessionType.Incidental &&
                a.Activity?.Classification != activityClassification.Event
        });

        const frequencyMap = filtered.reduce((acc, curr) => {
            const id = curr.AccountID;
            acc[id] = (acc[id] || 0) + 1;
            return acc;
        }, {});

        const grouped = filtered.reduce((acc, curr) => {
            const id = curr.AccountID;
            if (!acc[id]) {
                acc[id] = { ActualCount: 0 };
            }

            if ([statusMapping.success, statusMapping.recovered, statusMapping.advanced].includes(curr.Status)) {
                acc[id].ActualCount += 1;
            }

            return acc;
        }, {});

        const result = Object.entries(grouped).map(([AccountID, counts]) => {

            return {
                AccountID,
                ActualCount: counts.ActualCount,
                TotalFrequency: frequencyMap[AccountID] || 0
            };
        });

        const totalMatched = result.reduce((sum, entry) => {
            return sum + (entry.TotalFrequency === entry.ActualCount ? 1 : 0);
        }, 0);

        const totalCustomer = [...new Set(filtered.map(a => a.AccountID))].length;
        return [
            {
                ID: 1,
                Title: "Call Frequency",
                Progress: totalMatched || 0,
                Total: totalCustomer || 0
            }
        ];
    } else if (requestBody.id === "R6") {
        const Cycle = await getRecordById("Cycle", cyclePeriod);

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const filtered = report
            .filter(a => {
                const sessionDate = new Date(a.SessionDate);
                sessionDate.setHours(0, 0, 0, 0);

                return (
                    a.CyclePeriodID === cyclePeriod &&
                    a.SyncStatus !== SyncStatusMap.done &&
                    a.Tag == null &&
                    a.Activity?.Classification != activityClassification.Event &&
                    [statusMapping.pending, statusMapping.inprogress].includes(a.Status) &&
                    sessionDate < today
                    // a.Status === 2 //declared disapproved missed call
                );
            })
            .map(a => {
                const sessionDate = new Date(a.SessionDate);
                sessionDate.setHours(0, 0, 0, 0);
                return { ...a, SessionDate: sessionDate };
            });

        const result = Cycle.SubCycle.map((sub, index) => {
            const start = new Date(sub.StartDate);
            const end = new Date(sub.EndDate);
            start.setHours(0, 0, 0, 0);
            end.setHours(0, 0, 0, 0);

            const count = filtered.filter(f =>
                f.SessionDate >= start && f.SessionDate <= end
            ).length;

            return {
                ID: sub.Index,
                CycleIndex: sub.Index,
                SubCycle: `W${sub.Index}`, // or sub.Index if available
                Value: count
            };
        });

        return result;
    } else if (requestBody.id === "R7") {
        const Cycle = await getRecordById("Cycle", cyclePeriod);

        const filtered = report
            .filter(a => {
                return (
                    a.CyclePeriodID === cyclePeriod &&
                    a.SyncStatus !== SyncStatusMap.done &&
                    a.Type === sessionType.Incidental &&
                    a.Status === statusMapping.success &&
                    a.Activity?.Classification != activityClassification.Event
                );
            })
            .map(a => {
                const sessionDate = new Date(a.SessionDate);
                sessionDate.setHours(0, 0, 0, 0);
                return { ...a, SessionDate: sessionDate };
            });

        const result = Cycle.SubCycle.map((sub, index) => {
            const start = new Date(sub.StartDate);
            const end = new Date(sub.EndDate);
            start.setHours(0, 0, 0, 0);
            end.setHours(0, 0, 0, 0);

            const count = filtered.filter(f =>
                f.SessionDate >= start && f.SessionDate <= end
            ).length;

            return {
                ID: sub.Index,
                CycleIndex: sub.Index,
                SubCycle: `W${sub.Index}`, // or sub.Index if available
                Value: count
            };
        });

        return result;
    } else if (requestBody.id === "R8") {
        const Cycle = await getRecordById("Cycle", cyclePeriod);

        const filtered = report
            .filter(a => {
                return (
                    a.CyclePeriodID === cyclePeriod &&
                    a.SyncStatus !== SyncStatusMap.done &&
                    a.Status === statusMapping.advanced &&
                    a.Activity?.Classification != activityClassification.Event
                );
            })
            .map(a => {
                const sessionDate = new Date(a.SessionDate);
                sessionDate.setHours(0, 0, 0, 0);
                return { ...a, SessionDate: sessionDate };
            });

        const result = Cycle.SubCycle.map((sub, index) => {
            const start = new Date(sub.StartDate);
            const end = new Date(sub.EndDate);
            start.setHours(0, 0, 0, 0);
            end.setHours(0, 0, 0, 0);

            const count = filtered.filter(f =>
                f.SessionDate >= start && f.SessionDate <= end
            ).length;

            return {
                ID: sub.Index,
                CycleIndex: sub.Index,
                SubCycle: `W${sub.Index}`, // or sub.Index if available
                Value: count
            };
        });

        return result;
    } else if (requestBody.id === "R9") {
        const Cycle = await getRecordById("Cycle", cyclePeriod);

        const filtered = report
            .filter(a => {
                return (
                    a.CyclePeriodID === cyclePeriod &&
                    a.SyncStatus !== SyncStatusMap.done &&
                    a.Status === statusMapping.recovered &&
                    a.Activity?.Classification != activityClassification.Event
                );
            })
            .map(a => {
                const sessionDate = new Date(a.SessionDate);
                sessionDate.setHours(0, 0, 0, 0);
                return { ...a, SessionDate: sessionDate };
            });

        const result = Cycle.SubCycle.map((sub, index) => {
            const start = new Date(sub.StartDate);
            const end = new Date(sub.EndDate);
            start.setHours(0, 0, 0, 0);
            end.setHours(0, 0, 0, 0);

            const count = filtered.filter(f =>
                f.SessionDate >= start && f.SessionDate <= end
            ).length;

            return {
                ID: sub.Index,
                CycleIndex: sub.Index,
                SubCycle: `W${sub.Index}`, // or sub.Index if available
                Value: count
            };
        });

        return result;
    } else if (requestBody.id === "R10") {
        const Cycle = await getRecordById("Cycle", cyclePeriod);

        const filtered = report
            .filter(a => {
                return (
                    a.CyclePeriodID === cyclePeriod &&
                    a.SyncStatus !== SyncStatusMap.done &&
                    a.Tag == null &&
                    a.Joint &&
                    a.Activity?.Classification != activityClassification.Event &&
                    [statusMapping.success, statusMapping.recovered, statusMapping.advanced].includes(a.Status)
                );
            })
            .map(a => {
                const sessionDate = new Date(a.SessionDate);
                sessionDate.setHours(0, 0, 0, 0);
                return { ...a, SessionDate: sessionDate };
            });

        const result = Cycle.SubCycle.map((sub, index) => {
            const start = new Date(sub.StartDate);
            const end = new Date(sub.EndDate);
            start.setHours(0, 0, 0, 0);
            end.setHours(0, 0, 0, 0);

            const count = filtered.filter(f =>
                f.SessionDate >= start && f.SessionDate <= end
            ).length;

            return {
                ID: sub.Index,
                CycleIndex: sub.Index,
                SubCycle: `W${sub.Index}`, // or sub.Index if available
                Value: count
            };
        });

        return result;
    } else if (requestBody.id === "R11") {
        return [
            {
                "ID": 1,
                "CyclePeriodID": Number(cyclePeriod),
                "Remaining": 15,
                "Pending": 205,
                "ActualSales": 0,
                "Target": 0,
                "LYSales": 0,
                "Performance": 0,
                "Growth": 0
            }
        ]
    } else if (requestBody.id === "R12") {
        const Announcements = await getAll("Announcements");
        return Announcements;
    } else if (requestBody.id === "R13") {
        return [1]; // just to dispkay the visual
    } else if (requestBody.id === "R14") {
        return [1]; // just to dispkay the visual
    } else if (requestBody.id === "R15") {
        return [1]; // just to dispkay the visual
    } else if (requestBody.id === "R6.1") {
        const Cycle = await getRecordById("Cycle", cyclePeriod);

        const SubCycleIndex = requestBody.params.find(item => item.key === "CycleIndex")?.value;

        const SubCycle = Cycle.SubCycle.find(a => a.Index === Number(SubCycleIndex));

        const start = new Date(SubCycle.StartDate);
        const end = new Date(SubCycle.EndDate);
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const filtered = report.filter(a => {
            const sessionDate = new Date(a.SessionDate);
            sessionDate.setHours(0, 0, 0, 0);

            return (
                a.CyclePeriodID === cyclePeriod &&
                a.SyncStatus !== SyncStatusMap.done &&
                a.Tag == null &&
                a.Activity?.Classification != activityClassification.Event &&
                [statusMapping.pending, statusMapping.inprogress].includes(a.Status) &&
                sessionDate < today &&
                sessionDate >= start &&
                sessionDate <= end
            );
        });

        const result = await Promise.all(
            filtered.map(async a => {
                const account = await getRecordById("customer", a.AccountID);
                return {
                    ...a,
                    AccountName: account ? account?.Name : null,
                    Status: statusDisplayNames[a.Status] || null
                };
            })
        );

        return result;
    } else if (requestBody.id === "R7.1") {
        const Cycle = await getRecordById("Cycle", cyclePeriod);

        const SubCycleIndex = requestBody.params.find(item => item.key === "CycleIndex")?.value;
        const SubCycle = Cycle.SubCycle.find(a => a.Index === Number(SubCycleIndex));

        const start = new Date(SubCycle.StartDate);
        const end = new Date(SubCycle.EndDate);
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const filtered = report.filter(a => {
            const sessionDate = new Date(a.SessionDate);
            sessionDate.setHours(0, 0, 0, 0);

            return (
                a.CyclePeriodID === cyclePeriod &&
                a.SyncStatus !== SyncStatusMap.done &&
                a.Type === sessionType.Incidental &&
                a.Activity?.Classification != activityClassification.Event &&
                a.Status === statusMapping.success &&
                sessionDate >= start &&
                sessionDate <= end
            );
        });

        const result = await Promise.all(
            filtered.map(async a => {
                const account = await getRecordById("customer", a.AccountID);
                return {
                    ...a,
                    AccountName: account ? account?.Name : null,
                    Status: statusDisplayNames[a.Status] || null
                };
            })
        );

        return result;
    } else if (requestBody.id === "R8.1") {
        const Cycle = await getRecordById("Cycle", cyclePeriod);

        const SubCycleIndex = requestBody.params.find(item => item.key === "CycleIndex")?.value;
        const SubCycle = Cycle.SubCycle.find(a => a.Index === Number(SubCycleIndex));

        const start = new Date(SubCycle.StartDate);
        const end = new Date(SubCycle.EndDate);
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const filtered = report.filter(a => {
            const sessionDate = new Date(a.SessionDate);
            sessionDate.setHours(0, 0, 0, 0);

            return (
                a.CyclePeriodID === cyclePeriod &&
                a.Activity?.Classification != activityClassification.Event &&
                a.SyncStatus !== SyncStatusMap.done &&
                a.Status === statusMapping.advanced &&
                sessionDate >= start &&
                sessionDate <= end
            );
        });

        const result = await Promise.all(
            filtered.map(async a => {
                const account = await getRecordById("customer", a.AccountID);
                return {
                    ...a,
                    AccountName: account ? account?.Name : null,
                    Status: statusDisplayNames[a.Status] || null
                };
            })
        );

        return result;
    } else if (requestBody.id === "R9.1") {
        const Cycle = await getRecordById("Cycle", cyclePeriod);

        const SubCycleIndex = requestBody.params.find(item => item.key === "CycleIndex")?.value;
        const SubCycle = Cycle.SubCycle.find(a => a.Index === Number(SubCycleIndex));

        const start = new Date(SubCycle.StartDate);
        const end = new Date(SubCycle.EndDate);
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const filtered = report.filter(a => {
            const sessionDate = new Date(a.SessionDate);
            sessionDate.setHours(0, 0, 0, 0);

            return (
                a.CyclePeriodID === cyclePeriod &&
                a.Activity?.Classification != activityClassification.Event &&
                a.SyncStatus !== SyncStatusMap.done &&
                a.Status === statusMapping.recovered &&
                sessionDate >= start &&
                sessionDate <= end
            );
        });

        const result = await Promise.all(
            filtered.map(async a => {
                const account = await getRecordById("customer", a.AccountID);
                return {
                    ...a,
                    AccountName: account ? account?.Name : null,
                    Status: statusDisplayNames[a.Status] || null
                };
            })
        );

        return result;
    } else if (requestBody.id === "R10.1") {
        const Cycle = await getRecordById("Cycle", cyclePeriod);

        const SubCycleIndex = requestBody.params.find(item => item.key === "CycleIndex")?.value;
        const SubCycle = Cycle.SubCycle.find(a => a.Index === Number(SubCycleIndex));

        const start = new Date(SubCycle.StartDate);
        const end = new Date(SubCycle.EndDate);
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const filtered = report.filter(a => {
            const sessionDate = new Date(a.SessionDate);
            sessionDate.setHours(0, 0, 0, 0);

            return (
                a.CyclePeriodID === cyclePeriod &&
                a.SyncStatus !== SyncStatusMap.done &&
                a.Tag == null &&
                a.Joint &&
                a.Activity?.Classification != activityClassification.Event &&
                [statusMapping.success, statusMapping.recovered, statusMapping.advanced].includes(a.Status) &&
                sessionDate >= start &&
                sessionDate <= end
            );
        });

        const result = await Promise.all(
            filtered.map(async a => {
                const account = await getRecordById("customer", a.AccountID);
                return {
                    ...a,
                    AccountName: account ? account?.Name : null,
                    Status: statusDisplayNames[a.Status] || null
                };
            })
        );

        return result;
    }

    return [];
};